// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchInterestTags-cls1_87B","cls2":"ResearchInterestTags-cls2_rDd ResearchInterestTags-cls1_87B"};